export { wrapPageElement } from "./src";
import "../../src/css/style.scss";
